/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const isJiraConfluencePageContentEnabled = {
	get(): boolean {
		return fg('jira_preview_panel_m_1_rollout');
	},
};

export default isJiraConfluencePageContentEnabled;
